export default "/assets/images/cc-filter-room-02.c103b69b27bdb33d.png";